import React from 'react';
import PropTypes from 'prop-types';
import {graphql} from 'gatsby';

import Page from '../models/Page';

import Layout from '../components/Layout';
import SEO from '../components/SEO';
import TopicHeader from '../components/TopicHeader';
import TopicPlatform from '../components/TopicPlatform';

export default function render({data}) {
  const page = Page.fromWP(data.wordpressPage);

  return (
    <Layout marginRight={true} solidHeader={true}>
      <SEO title={page.title} description={page.excerpt} ogimage={page.ogimage} />
      <TopicHeader page={page} />
      <TopicPlatform slug={page.slug} projects={data.children.edges.map(edge => edge.node)} data={data.platform} />
    </Layout>
  );
}

render.propTypes = {
  data: PropTypes.object,
};

export const query = graphql`
  query($id: String!, $slug: String!) {
    wordpressPage(id: {eq: $id}) {
      ...WPPage
    }

    children: allWordpressPage(filter: {parent_element: {id: {eq: $id}}}) {
      edges {
        node {
          title
          excerpt
          acf {
            codigo
            status
            url
          }
        }
      }
    }

    platform: topicsJson(slug: {eq: $slug}) {
      html
      proposals
      multi {
        title
        proposals
      }
      done
    }
  }
`;
